import { DASHBOARD_TO_ADD_TO_PARAM } from '@modules/analysis/constants';
import { decompressURLSearchParams } from '@modules/common/utils';
import { populatePayloadFromSearchParams } from '@modules/common/utils/populatePayloadFromSearchParams';
import { GetUseInSearchLinkOptions } from './getUseInSearchLink';

export const isQueryParamsPresentInURL = (): boolean => {
  const searchParams = new URLSearchParams(document.location.search);

  if (searchParams.has(DASHBOARD_TO_ADD_TO_PARAM)) {
    return true;
  }

  const queryPayload: Partial<GetUseInSearchLinkOptions> = {};
  populatePayloadFromSearchParams(
    queryPayload,
    ['duration', 'where', 'from', 'to', 'prompt'],
    decompressURLSearchParams,
  );
  return Object.keys(queryPayload).length > 0;
};
